const TYPE = {
  CARD_GO_LEGENDS: 'CARD_GO_LEGENDS',
};

export default {TYPE};
